import type { SetValueOptions } from './types';

export function resolveSetValueSilence(opt?: SetValueOptions): {
  silenceInput: boolean;
  silenceChange: boolean;
  silenceHistory: boolean;
} {
  const silenceEvents = opt?.silenceEvents ?? false;
  const silenceInput = silenceEvents || (opt?.silenceInputEv ?? false);
  const silenceChange = silenceEvents || (opt?.silenceChangeEv ?? false);
  const silenceHistory = opt?.silenceHistory ?? false;

  return { silenceInput, silenceChange, silenceHistory };
}

export function upgradeProperty<T extends object>(host: T, prop: string): void {
  if (Object.prototype.hasOwnProperty.call(host, prop)) {
    const value = (host as any)[prop];
    delete (host as any)[prop];
    (host as any)[prop] = value;
  }
}
